'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowLeft, IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LlmBlock, LlmChunkEventGroup } from '../../../types';
import { clamp } from '../../utils';
import { Event } from '../Event/event';

export const EventGroup: React.FC<LlmBlock<LlmChunkEventGroup>> = (props) => {
  const { item } = props;

  useWindowSize();

  const classNames = getClassNames('llm__events');
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 24),
    slidesPerView: 1.1,
    watchOverflow: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    breakpoints: {
      630: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  };

  return (
    <div className={classNames}>
      <Swiper {...swiperProps}>
        <div className="llm__events-nav">
          <button ref={navigationPrevRef}><IconLlmArrowLeft /></button>
          <button ref={navigationNextRef}><IconLlmArrowRight /></button>
        </div>
        {item.items.map((item, i) => (
          <SwiperSlide key={i} className="llm__events-slide">
            <Event {...props} item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

